import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Negotiation } from '../interfaces/negotiation';

@Injectable({
  providedIn: 'root'
})
export class NegotiationService {
  http = inject(HttpClient);
  constructor () { }
  getNegotiationStates () {
    return this.http.get('/api/negotiations/states');
  };

  getNegotiationsForCampaign (campaign): Observable<Negotiation[]> {
    return this.http.get<Negotiation[]>('/api/negotiations/all/' + campaign._id);
  };

  getNegotiationCountForRaceId$ (raceId): Observable<number> {
    return this.http.get<number>('/api/negotiations/count/race/' + raceId);
  };

  getNegotiationsForRaceId (raceId) {
    return this.http.get('/api/negotiations/race/' + raceId);
  };

  getNegotiationForId (negotiationId) {
    return this.http.get('/api/negotiations/' + negotiationId);
  };

  // getNegotiationStatusForRaceNegotiationId (reid) {
  //     return this.http.get('/api/negotiations/status/reid/' + reid).then(
  //         function (response) {
  //             return response.data;
  //         }
  //     );
  // };

  // setStatusToSetupForRaceNegotiationId (reid) {
  //     return this.http.put('/api/negotiations/setup/reid/'+reid).then(
  //         function (response) {
  //             return response.data;
  //         }
  //     );
  // };

  // setStatusToReadyForRaceNegotiationId (reid) {
  //     return this.http.put('/api/negotiations/ready/reid/'+reid).then(
  //         function (response) {
  //             return response.data;
  //         }
  //     );
  // };

  // saveNewNegotiation (Negotiation) {
  //     return this.http.post('/api/negotiations', Negotiation).then(
  //         function (response) {
  //             return response.data;
  //         }
  //     );
  // };

  // saveNegotiation (Negotiation) {
  //     if (Negotiation._id != null) {
  //         return this.http.put('/api/negotiations/id/' + Negotiation._id, Negotiation).then(
  //             function (response) {
  //                 return response.data;
  //             }
  //         );
  //     } else {
  //         return saveNewNegotiation(Negotiation);
  //     }
  // };

  // resetNegotiation (Negotiation) {
  //     if (Negotiation._id != null) {
  //         return this.http.put('/api/negotiations/' + Negotiation._id + '/reset').then(
  //             function (response) {
  //                 return response.data;
  //             }
  //         );
  //     }
  // };

  // terminateNegotiation (Negotiation) {
  //     if (Negotiation._id != null) {
  //         return this.http.put('/api/negotiations/' + Negotiation._id + '/terminate').then(
  //             function (response) {
  //                 return response.data;
  //             }
  //         );
  //     }
  // };

  deleteNegotiation (negotiation) {
    if (negotiation._id == null) {
      throw new Error('negotiation._id is null');
    }
    return this.http.delete('/api/negotiations/' + negotiation._id);
  };
}
